export enum GroupStatus {
  NO_REQUESTS = 'NoRequests',
  RERATE_ALL = 'ReRate',
  RERATE_COMPLETED = 'ReRateCompleted',
  RERATE_REQUESTED = 'ReRateRequested',
  HIGH_RISK_ALL = 'HighRisk',
  HIGH_RISK = 'HighRiskApplied',
  HIGH_RISK_REQUESTED = 'HighRiskRequested',
  TIER2_ALL = 'Tier2',
  TIER2_REQUESTED = 'Tier2Requested',
  TIER2_DECLINED = 'Tier2Declined',
  TIER2_APPROVED = 'Tier2Approved',
  TIER2_COMPLETED = 'Tier2Completed',
  ARCHIVED = 'Archived',
  COMPLETED = 'GroupCompleted',
};

export enum APIStatus {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
  COMPLETE = 'COMPLETE',
};

export enum FileUploadStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export interface IFileUpload {
  type: 'bafo' | 'email_retention';
  guid: string | undefined;
  name: string;
  size: string | null | undefined;
  createdBy: string | null | undefined;
  createdAt: Date | undefined;
}

export type OptionValue = {
  label?: string;
  value: unknown;
}